module.exports = __webpack_public_path__ + "static/media/modernizacion.34fa31d5.png";